import { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useApp } from '../../../../hook/app.hook';
import { Question, Section } from '../../../../response/test.response';
import { getLanguageContent } from '../../../../util/language.util';

const keyPadArray = ['7', '8', '9', '4', '5', '6', '3', '2', '1', '0', '.'];

const IntigerAnsComponent = () => {
  const { testRes, saveQuestionResponse, language } = useApp();

  const question = testRes.sectionList
    .filter((section: Section) => section.active)[0]
    .questionList.filter((question: Question, index: number) => {
      return question.active;
    })[0];

  const [selectedNum, setselectedNum] = useState(
    getLanguageContent(question.candidateAnswer, language) ?? '',
  );
  const [inputvalue, setInputvalue] = useState(selectedNum);

  const removeNumber = () => {
    if (inputvalue) {
      let arr = inputvalue.split('');
      arr.pop();
      let newStr = arr.join('');
      setInputvalue(newStr);
      if (!newStr) {
        setselectedNum('');
      }
    }
  };

  const handleKeyPadAction = (e: any) => {
    const num = e.target.textContent;
    if (num === '.' && inputvalue.includes('.')) return;
    const newVal = inputvalue + num;
    setInputvalue(newVal);
    setselectedNum(newVal);
  };

  const handleInput = (e: any) => {
    let newNumberStr = e.target.value;
    newNumberStr = newNumberStr.replace(/[^0-9.]/g, '');
    const parts = newNumberStr.split('.');
    if (parts.length > 2) {
      newNumberStr = parts[0] + '.' + parts.slice(1).join('');
    }

    setselectedNum(newNumberStr);
  };

  useEffect(() => {
    if (selectedNum && selectedNum.length > 0) {
      const candidateAnswer = { [language]: selectedNum };
      saveQuestionResponse(question.id, candidateAnswer, null);
    }
  }, [selectedNum, language]);

  useEffect(() => {
    const ans = getLanguageContent(question.candidateAnswer, language) ?? '';
    setselectedNum(ans);
    setInputvalue(ans);
  }, [question.id, language]);

  return (
    <div className="number-keypad">
      <Form.Control
        type="text"
        id="numberKeyPadInput"
        aria-describedby="passwordHelpBlock"
        value={inputvalue}
        defaultValue={inputvalue}
        onChange={handleInput}
        className="text-center me-2 number-input no-pointer-events"
      />

      <div className="d-flex my-4 flex-wrap">
        {keyPadArray.map((num, index) => {
          return (
            <Button
              variant={selectedNum === num ? 'white' : 'whisper'}
              onClick={handleKeyPadAction}
              className={`w-70-px px-3 py-2 me-2 mb-2 text-center c-pointer ${
                selectedNum === num ? 'border-primary' : 'border-transparent'
              } `}
            >
              {num}
            </Button>
          );
        })}
        <Button
          variant="whisper"
          className="w-70-px px-3 py-2 me-2 mb-2 text-center"
          onClick={removeNumber}
        >
          <img src="/images/keypad-cross.svg" alt="" />
        </Button>
      </div>
    </div>
  );
};

export default IntigerAnsComponent;
